<script>
    import "../../../../../app.css";
    import HowToPublishItem from "./how-to-publish-item.svelte";
    import { t } from "$lib/i18n.js";
</script>

<img class="wave" src="https://assets.auting.it/images/waves/how-to-publish/top/waves.svg" alt="Waves" />
<section>
    
    <div>
        <h2>{@html $t('routes.owner.how_to_publish.title')}</h2>
        <h2 class="orange">{$t('routes.owner.how_to_publish.title_accent')}</h2>
    </div>

    <div class="steps">
        <div class="arrows arrow-top">
            <img src="https://assets.auting.it/images/arrows/how-to-publish/top/arrow.svg" alt="Arrow" />
        </div>
        <div class="items">
            <HowToPublishItem headline={$t('routes.owner.how_to_publish.cols.1.headline')} subheadline={$t('routes.owner.how_to_publish.cols.1.subheadline')} />
            <HowToPublishItem headline={$t('routes.owner.how_to_publish.cols.2.headline')} subheadline={$t('routes.owner.how_to_publish.cols.2.subheadline')} />
            <HowToPublishItem headline={$t('routes.owner.how_to_publish.cols.3.headline')} subheadline={$t('routes.owner.how_to_publish.cols.3.subheadline')} />    
            <HowToPublishItem headline={$t('routes.owner.how_to_publish.cols.4.headline')} subheadline={$t('routes.owner.how_to_publish.cols.4.subheadline')} />
        </div>
        <div class="arrows arrows-bottom">
            <img src="https://assets.auting.it/images/arrows/how-to-publish/bottom/arrow_1.svg" alt="Arrow" />
            <img src="https://assets.auting.it/images/arrows/how-to-publish/bottom/arrow_2.svg" alt="Arrow" />
        </div>
    </div>

</section>
<img class="wave" src="https://assets.auting.it/images/waves/how-to-publish/bottom/waves.svg" alt="Waves" />

<style>
    section {
        background: var(--on-surface);
        padding-top: 150px;
        padding-bottom: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 40px;
    }

    h2 {
        margin: 0;
        padding: 0;
        text-align: center;
        color: var(--surface);
        font-family: var(--font-body);
    }

    h2.orange {
        color: var(--orange);
        font-family: var(--font-heading);
        margin-top: 8px;
    }

    .steps {
        max-width: var(--max-width);
        width: 100%;
        gap: 0px;
    }

    .steps .arrow-top {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 80px;
    }

    .steps .items {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 40px;
    }

    .steps .arrows-bottom {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        margin-top: 32px;
        height: 80px;
    }

    .wave {
        width: 100vw;
    }

    @media (max-width: 768px) {
        section {
            padding-top: 100px;
            padding-bottom: 80px;
        }

        h2 {
            font-size: 32px;
        }

        .steps .arrow-top,
        .steps .arrows-bottom {
            height: 60px;
            display: none;
        }

        .steps .items {
            flex-direction: column;
            align-items: center;
            gap: 20px;
        }
    }
</style>
